__turbopack_context__.v({
  "className": "brandfont_2b18ba7f-module__U_8gGa__className",
});
